import { render, staticRenderFns } from "./date-block.html?vue&type=template&id=382cb427&scoped=true&"
import script from "./date-block.js?vue&type=script&lang=js&"
export * from "./date-block.js?vue&type=script&lang=js&"
import style0 from "./date-block.scss?vue&type=style&index=0&id=382cb427&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382cb427",
  null
  
)

export default component.exports